import { useState, useRef, useEffect } from 'react';

const C = {
  navy:      '#1B2B4B',
  gold:      '#B8963E',
  goldLight: '#D4AE5A',
  white:     '#FFFFFF',
  offWhite:  '#F8F7F4',
  border:    'rgba(27,43,75,0.12)',
  green:     '#4ade80',
};

const API_BASE = process.env.REACT_APP_API_URL || '';

// â”€â”€ Size presets â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const SIZE = {
  default:  { width: 340, height: 280 },
  expanded: { width: 480, height: 460 },
};

// â”€â”€ Icons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function TruckIcon({ size = 20, color = '#fff', strokeWidth = 1.8 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13" rx="2" />
      <path d="M16 8h4l3 5v3h-7V8z" />
      <circle cx="5.5" cy="18.5" r="2.5" />
      <circle cx="18.5" cy="18.5" r="2.5" />
    </svg>
  );
}

function SendIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

// Expand icon (two arrows pointing out)
function ExpandIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 3 21 3 21 9" />
      <polyline points="9 21 3 21 3 15" />
      <line x1="21" y1="3" x2="14" y2="10" />
      <line x1="3" y1="21" x2="10" y2="14" />
    </svg>
  );
}

// Collapse icon (two arrows pointing in)
function CollapseIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="4 14 10 14 10 20" />
      <polyline points="20 10 14 10 14 4" />
      <line x1="10" y1="14" x2="3" y2="21" />
      <line x1="21" y1="3" x2="14" y2="10" />
    </svg>
  );
}

// â”€â”€ Sub-components â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function BotAvatar({ size = 28 }) {
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: C.navy, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <TruckIcon size={size * 0.5} color={C.gold} strokeWidth={2} />
    </div>
  );
}

function TypingIndicator() {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      <BotAvatar />
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '10px 13px', background: C.white, border: `1px solid ${C.border}`, borderRadius: '14px 14px 14px 4px' }}>
        {[0, 0.2, 0.4].map((delay, i) => (
          <div key={i} style={{ width: 6, height: 6, borderRadius: '50%', background: C.gold, animation: `cst-bounce 1.2s ${delay}s infinite` }} />
        ))}
      </div>
    </div>
  );
}

function Message({ msg, expanded }) {
  const isUser = msg.role === 'user';
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flexDirection: isUser ? 'row-reverse' : 'row' }}>
      {!isUser && <BotAvatar />}
      <div style={{
        maxWidth: expanded ? 320 : 220,
        padding: '10px 13px',
        borderRadius: isUser ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
        background: isUser ? C.navy : C.white,
        border: isUser ? 'none' : `1px solid ${C.border}`,
        color: isUser ? C.white : C.navy,
        fontSize: expanded ? 14 : 13,
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
        transition: 'max-width 0.3s, font-size 0.3s',
      }}>
        {msg.text}
      </div>
    </div>
  );
}

const QUICK_REPLIES = [
  { label: 'CDL programs',     text: 'What CDL programs do you offer?' },
  { label: 'Tuition & cost',   text: 'How much is tuition?' },
  { label: 'Veteran benefits', text: 'Do you accept GI Bill?' },
  { label: 'How to enroll',    text: 'How do I enroll?' },
];

const WELCOME_MESSAGE = {
  role: 'bot',
  text: 'Welcome to California School of Trucking. I can help you with CDL programs, tuition, veteran benefits, enrollment, and more.\n\nWhat would you like to know?',
  showQuickReplies: true,
};

// â”€â”€ Main widget â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export default function ChatbotWidget() {
  const [open, setOpen]         = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [messages, setMessages] = useState([WELCOME_MESSAGE]);
  const [input, setInput]       = useState('');
  const [typing, setTyping]     = useState(false);
  const [showLabel, setShowLabel] = useState(true);
  const bodyRef                 = useRef(null);

  const currentSize = expanded ? SIZE.expanded : SIZE.default;

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages, typing]);

  useEffect(() => {
    const t = setTimeout(() => setShowLabel(false), 6000);
    return () => clearTimeout(t);
  }, []);

  const sendMessage = async (text) => {
    const trimmed = text.trim();
    if (!trimmed || typing) return;

    setMessages((prev) => [...prev, { role: 'user', text: trimmed }]);
    setInput('');
    setTyping(true);

    try {
      const history = messages.map((m) => ({ role: m.role, text: m.text }));
      const res = await fetch(`${API_BASE}/api/chatbot`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ message: trimmed, history }),
      });
      const data = await res.json();
      setMessages((prev) => [...prev, { role: 'bot', text: data.reply }]);
    } catch {
      setMessages((prev) => [...prev, {
        role: 'bot',
        text: "I'm having trouble connecting right now. Please call us at 1-888-498-2689 or visit caschooloftrucking.com.",
      }]);
    } finally {
      setTyping(false);
    }
  };

  return (
    <>
      <style>{`
        @keyframes cst-bounce {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-5px); }
        }
        @keyframes cst-pop {
          from { opacity: 0; transform: scale(0.92) translateY(8px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes cst-label-in {
          from { opacity: 0; transform: translateX(10px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>

      {/* â”€â”€ Chat window â”€â”€ */}
      {open && (
        <div style={{
          position: 'fixed',
          bottom: 88,
          right: 24,
          zIndex: 9999,
          width: currentSize.width,
          borderRadius: 16,
          overflow: 'hidden',
          border: `1px solid ${C.border}`,
          boxShadow: '0 8px 40px rgba(27,43,75,0.2)',
          fontFamily: "'Source Sans 3', sans-serif",
          animation: 'cst-pop 0.2s ease',
          transition: 'width 0.3s ease, height 0.3s ease',
        }}>

          {/* Header */}
          <div style={{ background: C.navy, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', background: C.gold, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <TruckIcon size={19} color={C.white} strokeWidth={1.8} />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: C.white, fontSize: expanded ? 15 : 14, fontWeight: 600, transition: 'font-size 0.3s' }}>CST Admissions Assistant</div>
              <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 11, marginTop: 2, display: 'flex', alignItems: 'center', gap: 5 }}>
                <div style={{ width: 7, height: 7, borderRadius: '50%', background: C.green }} />
                California School of Trucking
              </div>
            </div>

            {/* Expand / Collapse button */}
            <button
              onClick={() => setExpanded((e) => !e)}
              title={expanded ? 'Collapse' : 'Expand'}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.45)', display: 'flex', padding: '4px 6px', borderRadius: 4, marginRight: 2 }}
              onMouseEnter={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; e.currentTarget.style.background = 'none'; }}
            >
              {expanded ? <CollapseIcon /> : <ExpandIcon />}
            </button>

            {/* Close button */}
            <button
              onClick={() => setOpen(false)}
              title="Close"
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'rgba(255,255,255,0.45)', display: 'flex', padding: '4px 6px', borderRadius: 4 }}
              onMouseEnter={e => { e.currentTarget.style.color = '#fff'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
              onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.45)'; e.currentTarget.style.background = 'none'; }}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Messages */}
          <div
            ref={bodyRef}
            style={{
              padding: 16,
              background: C.offWhite,
              display: 'flex',
              flexDirection: 'column',
              gap: 12,
              height: currentSize.height,
              overflowY: 'auto',
              transition: 'height 0.3s ease',
            }}
          >
            {messages.map((msg, i) => (
              <div key={i}>
                <Message msg={msg} expanded={expanded} />
                {msg.showQuickReplies && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8, marginLeft: 36 }}>
                    {QUICK_REPLIES.map((qr) => (
                      <button
                        key={qr.text}
                        onClick={() => sendMessage(qr.text)}
                        style={{ fontSize: 11, padding: '5px 10px', borderRadius: 20, border: `1px solid ${C.gold}`, color: C.gold, background: C.white, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s' }}
                        onMouseEnter={e => { e.currentTarget.style.background = C.gold; e.currentTarget.style.color = C.white; }}
                        onMouseLeave={e => { e.currentTarget.style.background = C.white; e.currentTarget.style.color = C.gold; }}
                      >
                        {qr.label}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {typing && <TypingIndicator />}
          </div>

          {/* Input */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px', borderTop: `1px solid ${C.border}`, background: C.white }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage(input)}
              placeholder="Ask about programs, tuition, enrollment..."
              disabled={typing}
              style={{ flex: 1, border: `1px solid ${C.border}`, borderRadius: 20, padding: '8px 14px', fontSize: 13, fontFamily: 'inherit', outline: 'none', color: C.navy, background: C.offWhite, opacity: typing ? 0.6 : 1 }}
              onFocus={e => e.target.style.borderColor = C.gold}
              onBlur={e => e.target.style.borderColor = C.border}
            />
            <button
              onClick={() => sendMessage(input)}
              disabled={typing}
              style={{ width: 34, height: 34, borderRadius: '50%', background: typing ? '#ccc' : C.gold, border: 'none', cursor: typing ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'background 0.15s' }}
              onMouseEnter={e => { if (!typing) e.currentTarget.style.background = C.goldLight; }}
              onMouseLeave={e => { if (!typing) e.currentTarget.style.background = C.gold; }}
            >
              <SendIcon />
            </button>
          </div>

          {/* Footer */}
          <div style={{ textAlign: 'center', fontSize: 10, color: 'rgba(27,43,75,0.3)', padding: '6px 0 10px', background: C.white, letterSpacing: '0.04em' }}>
            California School of Trucking · caschooloftrucking.com
          </div>
        </div>
      )}

      {/* â”€â”€ FAB button â”€â”€ */}
      {/* Label bubble */}
      {!open && showLabel && (
        <div style={{
          position: 'fixed', bottom: 34, right: 92, zIndex: 9998,
          background: C.navy, color: C.white,
          padding: '8px 12px', borderRadius: 20,
          fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap',
          boxShadow: '0 4px 14px rgba(27,43,75,0.28)',
          display: 'flex', alignItems: 'center', gap: 8,
          animation: 'cst-label-in 0.35s ease',
        }}>
          <span>How can I help you?</span>
          <button
            onClick={e => { e.stopPropagation(); setShowLabel(false); }}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              color: 'rgba(255,255,255,0.55)', fontSize: 16, lineHeight: 1,
              padding: 0, display: 'flex', alignItems: 'center',
            }}
          >&#x2715;</button>
          <div style={{
            position: 'absolute', right: -6, top: '50%', transform: 'translateY(-50%)',
            width: 0, height: 0,
            borderTop: '6px solid transparent',
            borderBottom: '6px solid transparent',
            borderLeft: `6px solid ${C.navy}`,
          }} />
        </div>
      )}

      <button
        onClick={() => { setOpen((o) => !o); setShowLabel(false); }}
        title="Chat with CST Admissions"
        style={{
          position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
          width: 60, height: 60, borderRadius: '50%',
          background: C.gold, border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(27,43,75,0.3)',
          transition: 'transform 0.2s, background 0.2s',
        }}
        onMouseEnter={e => { e.currentTarget.style.background = C.goldLight; e.currentTarget.style.transform = 'scale(1.06)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = C.gold; e.currentTarget.style.transform = 'scale(1)'; }}
      >
        <TruckIcon size={26} color={C.white} strokeWidth={1.8} />
      </button>
    </>
  );
}